import React from 'react'
import { BadgeProps } from './types'


const DEFAULT_PROPS = {
  badgeType: 'default',
  kind: 'primary',
}

export const StyledBadge: React.FC<BadgeProps> = ({
  badgeType = DEFAULT_PROPS.badgeType,
  kind = DEFAULT_PROPS.kind,
  className = '',
  children,
  ...rest
}) => {
  const badgeStyles = 'inline-flex items-center justify-center rounded-FULL font-bold text-center'

  const sizeStyles = {
    default: 'text-XS px-S',
    small: 'text-2XS px-XS',
  };

  const kindStyles = {
    primary: 'border-1 border-member-green-100 text-member-green-100 bg-member-gray-0',
    secondary: 'text-member-green-100 bg-member-light-green-100',
    danger: 'border-1 border-member-red-100 text-member-red-100 bg-member-gray-0',
    warning: 'border-1 border-member-orange-100 text-member-orange-100 bg-member-gray-0',
    gray: 'border-1 border-member-gray-50 text-member-gray-50 bg-member-gray-0',
    white: 'border-1 border-member-gray-0 text-member-gray-0 bg-transparent',
  }

  const resolvedBadgeType = badgeType ?? DEFAULT_PROPS.badgeType
  const resolvedKind = kind ?? DEFAULT_PROPS.kind

  return (
    <span
      className={`${badgeStyles} ${sizeStyles[resolvedBadgeType]} ${kindStyles[resolvedKind]} ${className}`}
      {...rest}
      style={{
        letterSpacing: '.02em',
        height: badgeType === 'default' ? '28px' : '18px',
        width: 'max-content',
        ...rest.style,
      }}
    >
      {children}
    </span>
  )
}
